import React, { useState, useCallback } from "react";

/**
 * KtruSourcesFilter
 * Styled to match the plain-input filter pattern (no MUI FormControl wrappers).
 */
const KtruSourcesFilter = ({ onFilterChange }) => {
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [status, setStatus] = useState("");

  const handleChange = useCallback(
    (field, value) => {
      const next = { search, type, status, [field]: value };
      if (field === "search") setSearch(value);
      if (field === "type") setType(value);
      if (field === "status") setStatus(value);
      onFilterChange(next);
    },
    [search, type, status, onFilterChange],
  );

  const handleClear = useCallback(() => {
    setSearch("");
    setType("");
    setStatus("");
    onFilterChange({ search: "", type: "", status: "" });
  }, [onFilterChange]);

  const hasActive = search || type || status;

  return (
    <div style={styles.wrapper}>
      {/* Search */}
      <div style={{ ...styles.group, flex: 1, minWidth: 220 }}>
        <label style={styles.label}>Поиск</label>
        <input
          type="text"
          value={search}
          onChange={(e) => handleChange("search", e.target.value)}
          placeholder="Код КТРУ или название..."
          style={styles.input}
          onFocus={(e) => (e.target.style.borderColor = "#4298D7")}
          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
        />
      </div>

      {/* Type */}
      <div style={styles.group}>
        <label style={styles.label}>Тип источника</label>
        <select
          value={type}
          onChange={(e) => handleChange("type", e.target.value)}
          style={styles.select}
          onFocus={(e) => (e.target.style.borderColor = "#4298D7")}
          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
        >
          <option value="">Все</option>
          <option value="marketplace">Маркетплейс</option>
          <option value="retailer">Ритейлер</option>
          <option value="wholesaler">Опт</option>
        </select>
      </div>

      {/* Status */}
      <div style={styles.group}>
        <label style={styles.label}>Статус</label>
        <select
          value={status}
          onChange={(e) => handleChange("status", e.target.value)}
          style={styles.select}
          onFocus={(e) => (e.target.style.borderColor = "#4298D7")}
          onBlur={(e) => (e.target.style.borderColor = "#d1d5db")}
        >
          <option value="">Все</option>
          <option value="true">Активные</option>
          <option value="false">Отключённые</option>
        </select>
      </div>

      {/* Clear button — only when something is active */}
      {hasActive && (
        <div style={{ ...styles.group, justifyContent: "flex-end" }}>
          <label style={{ ...styles.label, opacity: 0 }}>_</label>
          <button onClick={handleClear} style={styles.clearBtn}>
            Сбросить
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  wrapper: {
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    padding: "16px 20px",
    marginBottom: 16,
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    alignItems: "flex-end",
  },
  group: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  label: {
    fontSize: 12,
    color: "#6b7280",
    fontWeight: 500,
  },
  input: {
    padding: "8px 12px",
    border: "1px solid #d1d5db",
    borderRadius: 6,
    background: "#fff",
    fontSize: 13,
    color: "#111827",
    outline: "none",
    height: 38,
    transition: "border-color 0.15s",
    width: "100%",
  },
  select: {
    padding: "8px 12px",
    border: "1px solid #d1d5db",
    borderRadius: 6,
    background: "#fff",
    fontSize: 13,
    color: "#111827",
    outline: "none",
    height: 38,
    width: 170,
    cursor: "pointer",
  },
  clearBtn: {
    height: 38,
    padding: "0 14px",
    border: "1px solid #d1d5db",
    borderRadius: 6,
    background: "#fff",
    fontSize: 13,
    color: "#6b7280",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

export default KtruSourcesFilter;
